import { useState } from "react";

const useMaxLengthInput = () => {
  const [limitReached, setLimitReached] = useState({});

  const handleMaxLengthKeyDown = (e) => {
    const { name, value } = e.target;
    if (
      value.length >= 100 &&
      e.key.length === 1 &&
      !e.ctrlKey &&
      !e.metaKey &&
      !e.altKey
    ) {
      setLimitReached((prev) => ({ ...prev, [name]: true }));
    }
  };

  const clearLimitReached = (name) => {
    setLimitReached((prev) => {
      if (!prev[name]) return prev;
      const next = { ...prev };
      delete next[name];
      return next;
    });
  };

  return { limitReached, handleMaxLengthKeyDown, clearLimitReached };
};

export default useMaxLengthInput;
